import type { CurrentUser } from "@twinkltech/curriculum-architect-domain-hooks";

type MappedUserPermissions = {
  canViewCurricula: boolean;
};

export const userPermissions = (
  currentUser: CurrentUser | null
): MappedUserPermissions =>
  currentUser
    ? {
        canViewCurricula:
          currentUser.persona.isStaff ||
          !(
            currentUser.persona.accountType === "individual" &&
            (currentUser.persona.bundle === "Core" ||
              currentUser.persona.bundle === null)
          ),
      }
    : {
        canViewCurricula: false,
      };
